import cn from "classnames";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { toast } from "react-toastify";

import { useCookiebot } from "@hooks/useCookiebot";
import { useStore } from "@hooks/useZustandProvider";
import Button from "@ui-kit/Button/Button";
import CheckBox from "@ui-kit/CheckBox/CheckBox";
import TicketsInput from "@ui-kit/TicketsInput/TicketsInput";
import { regExpForEmail } from "@utils/utils";

import s from "./SubcriptionBox.module.scss";

const SubscriptionBox = ({ dark = true }) => {
  const { t } = useTranslation();
  const { user } = useStore();
  const { cookieConsent, exponea } = useCookiebot();

  const [termsCheck, setTermsCheck] = useState(false);

  const [email, setEmail] = useState(user.email);
  const [isValid, setIsValid] = useState(true);

  const validateEmail = (value) => {
    return regExpForEmail.test(value);
  };
  const handleSubscribe = () => {
    if (!validateEmail(email) || !termsCheck) {
      return setIsValid(false);
    }

    if (cookieConsent.marketing) {
      exponea.track(
        "email_subscription",
        {
          email,
          subscription_date: new Date(),
          source: "footer",
        },
        (data) => {
          if (data.status === "ok") {
            toast.success(t("footer.subscribe.notify.success"));
          }
        },
        (error) => {
          console.log("Subscription error:", error);

          toast.error(t("footer.subscribe.notify.error"));
        },
      );
    } else {
      toast.warn(t("footer.subscribe.notify.warn"));

      // showCookieBanner();
    }
  };

  const toggleTermsCheck = () => {
    setTermsCheck((prev) => !prev);
  };

  useEffect(() => {
    if (user.email) {
      setEmail(user.email);
    }
  }, [user.email]);

  return (
    <div className={cn(s.subscribe, dark && s.dark)}>
      <div className={s.block}>
        <TicketsInput
          className={s.email}
          withoutMessage
          value={email}
          errors={
            !(validateEmail(email) || isValid) &&
            t("validation.error.email", {
              field: "email",
            })
          }
          onChange={(e) => {
            const value = e.target.value;
            setEmail(value);
          }}
          placeholder={t("email")}
        />
        <Button text={t("join")} onClick={handleSubscribe} />
      </div>

      <div className={s.termsCheck}>
        <CheckBox
          error={!(termsCheck || isValid)}
          checked={termsCheck}
          onChange={toggleTermsCheck}
          dark={dark}
        />
        <div className={s.text}>
          <Trans i18nKey="footer.subscribe.terms.check.text">
            footer.subscribe.terms.check.text
            <Link className={s.link} href="/privacy-policy" />
          </Trans>
          {/* {t("footer.subscribe.terms.check.text")} */}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBox;
